var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\r\n    background: #E9DDEC;\r\n}\r\n\r\n.top-header::after {\r\n    background: url(" + escape(require("../../images/line.png")) + ");\r\n    background-position: top;\r\n    height: 10px;\r\n    width: 100%;\r\n    background-size: contain;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .top-header::after {\r\n        height: 15px;\r\n    }\r\n}", ""]);

// exports
